import { WaypointsMarkers } from "./waypoints-markers";
import { useActiveTrips, useAllTripWaypoints } from "@/api/trips";
import { useShortcutsStore } from "@/screens/dashboard/shortcuts.store";

interface TripWaypointsMarkersProps {
  zoomLevel: number;
}

export function TripWaypointsMarkers({ zoomLevel }: TripWaypointsMarkersProps) {
  const { tripFilter } = useShortcutsStore();

  // Fetch all active trips
  const { data: tripsResponse } = useActiveTrips();

  // Update trips reference to use data property
  const trips = tripsResponse?.data;

  // Fetch waypoints for all trips
  const { data: allWaypoints } = useAllTripWaypoints({ trips });

  // Early return if trips are not being shown or no waypoints
  if (
    (!tripFilter.showAll && tripFilter.visibleTripIds.length === 0) ||
    !allWaypoints?.length
  ) {
    return null;
  }

  return <WaypointsMarkers wayPoints={[allWaypoints]} zoomLevel={zoomLevel} />;
}
